import { Injectable } from '@angular/core';
import { Observable } from "rxjs/Observable";
import { HttpClient } from "@angular/common/http";

import { ResponseModel } from '../models/response.model';
import { HttpParams } from '@angular/common/http';
import { BaseService } from './base.service';
import { RolePage } from '../models/index';
import { MessageService } from 'primeng/components/common/messageservice';
import { PersistenceService } from 'angular-persistence';
import { environment } from '../../environments/environment';

@Injectable()
export class PermissionService extends BaseService {
  constructor(protected messageService: MessageService, protected httpClient: HttpClient, protected persistenceService: PersistenceService) {
    super(messageService, httpClient, persistenceService, environment.apiGeneralUrl, "permission");
  }
  
  public checkPermission(aliasPath: string): Observable<ResponseModel> {
    var params = new HttpParams();
    params = params.append("aliasPath", aliasPath);
    return super.getCustomApi("checkPermission", params);
  }

  public checkPermissionDetail(aliasPath: string, moduleId: any): Observable<ResponseModel> {
    var params = new HttpParams();
    params = params.append("aliasPath", aliasPath);
    params = params.append("moduleId", moduleId);

    return super.getCustomApi("CheckPermissionDetail", params);
  }

  public async checkPermissionAsync(aliasPath: string): Promise<any> {
    let res = await this.checkPermission(aliasPath).toPromise();
    
    if (res.isSuccess) {
      let data = res.data;
      return data;
    }
    return false;
  }

  public getByRoleId(roleId: any): Observable<ResponseModel> {
    var params = new HttpParams();
    params = params.append("roleId", roleId);
    return super.getCustomApi("getByRoleId", params);
  }

  public updatePermission(rolePages: RolePage[]): Observable<ResponseModel> {
    return super.postCustomApi("updatePermission", rolePages);
  }
}



// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/services/permission.service.ts